<template>
 <UserLayout  pageTitle="Pianificazione operatori">
      <template #page-content="props">
    <v-card class="form-card" style="width: 99%" outlined :elevation="10">
      <FrmPlanner 
      resource-type="Uomo"
      title=""
      v-bind:allow-drag-and-drop-events="false"
      v-bind:height="plannerHeight"></FrmPlanner>
    </v-card>
     </template>
 </UserLayout> 
</template>


<script>
import FrmPlanner from "../components/Planner/FrmPlanner";
import UserLayout from "../layout/UserLayout";
import UISettingsHelper from "../utils/UISettingsHelper";
import SessionHelper from "../utils/SessionHelper";
export default { 
    data:function(){
        return{ 
            windowHeight:0,
        }
    },
  components: {
    FrmPlanner,
    UserLayout,
  },
  mounted() {
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
      UISettingsHelper.Configure(this.$route.params.companyAlias); 
      this.windowHeight = window.innerHeight-300; 
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight-300;
    });
  },
  computed: {
    plannerHeight() { 
      return this.windowHeight-300+"px";
    }, 
    }
};
</script>